import cloneDeep from 'lodash.clonedeep';

import { type RichtextStoryblok } from './storyblok/storyblok';

export const replaceAllInterpolatedValues = (
  text?: RichtextStoryblok,
  values?: Record<string, string | number>,
  searchParams?: URLSearchParams,
): RichtextStoryblok | undefined => {
  const document = cloneDeep(text);

  if (!values && !searchParams?.size) return document;
  if (!document) return document;

  // replace any {{<key>}} keys with their values
  document?.content?.forEach((item) => replaceInterpolatedValues(item, values, searchParams));

  return document;
};

const replaceInterpolatedValues = (
  richText: RichtextStoryblok,
  values?: Record<string, string | number>,
  searchParams?: URLSearchParams,
) => {
  if (richText.text && values) {
    Object.keys(values).forEach((key) => {
      richText.text = richText.text?.replace(key, values?.[key]?.toString() ?? '');
    });
  }

  if (richText.text && searchParams) {
    searchParams.forEach((value, key) => {
      richText.text = richText.text?.replace(`{{${key}}}`, value);
    });
  }

  if (richText.content) {
    richText.content.forEach((contentItem) =>
      replaceInterpolatedValues(contentItem, values, searchParams),
    );
  }
};
